



















































































import Vue from 'vue'
import Container from '@/components/Container.vue'
import Logo from '@/components/icons/Logo.vue'

export default Vue.extend({
  components: {
    Container,
    Logo
  },
  data() {
    return {
      showNavbar: true,
      transparent: true,
      lastScrollPosition: 0,
      scrollOffset: 50,
      startAnimHome: false,
      startAnimContact: false,
      hoveringHome: false,
      hoveringContact: false
    }
  },
  computed: {
    isHome() {
      return this.$route.name === 'Home'
    },
    isContact() {
      return this.$route.name === 'Contact'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
    this.lastScrollPosition = window.pageYOffset
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },

  methods: {
    onScroll() {
      if (window.pageYOffset < 0) {
        return
      }
      if (
        Math.abs(window.pageYOffset - this.lastScrollPosition) <
        this.scrollOffset
      ) {
        return
      }
      this.showNavbar = window.pageYOffset < this.lastScrollPosition
      this.transparent = window.pageYOffset < this.scrollOffset
      this.lastScrollPosition = window.pageYOffset
    },
    enterHome() {
      this.hoveringHome = true
    },
    leaveHome() {
      this.hoveringHome = false
    },
    enterContact() {
      this.hoveringContact = true
    },
    leaveContact() {
      this.hoveringContact = false
    },
    animHome() {
      if (!this.startAnimHome) {
        this.startAnimHome = true
        this.hoveringContact = false
        setTimeout(() => (this.startAnimHome = false), 832)
        this.$router.push({ name: 'Home' })
      }
    },
    animContact() {
      if (!this.startAnimContact) {
        this.startAnimContact = true
        this.hoveringHome = false
        setTimeout(() => (this.startAnimContact = false), 800)
        this.$router.push({ name: 'Contact' })
      }
    }
  }
})
